// function Hero() {
//   return (
//     <section className="relative h-screen flex items-center justify-center overflow-hidden">

//       <div className="container-width section-padding w-full text-center pb-40">
//         <h1 className="sm:text-2xl md:text-2xl lg:text-8xl xl:text-7xl font-bold tracking-[0.15em] text-secondary/90 uppercase leading-none">
//           <div>Tamar Valley</div>
//           <div>Business</div>
//           <div>Association</div>
//         </h1>
//       </div>
      
//       {/* Scroll Indicator */}
//       <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
//         <div className="w-[1px] h-24 bg-gradient-to-b from-secondary to-transparent" />
//       </div>
//     </section>
//   )
// }

// export default Hero

function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="container-width section-padding w-full text-center">
        {/* Main Title - Minimal with fade-in animation */}
        <div className="space-y-12 animate-fade-in">
          <h1 className="text-8xl md:text-[12rem] lg:text-[14rem] tracking-[0.15em] text-secondary/60 leading-none animate-slide-up">
            TVBA
          </h1>
          
          {/* <div className="h-px w-32 bg-secondary/40 mx-auto animate-expand" /> */}
          <div className="h-px w-32 bg-gradient-to-b from-secondary to-transparent mx-auto animate-pulse-slow" />
          
          <p className="text-xl md:text-2xl tracking-[0.3em] text-secondary/40 uppercase animate-fade-in-delayed">
            Tamar Valley Business Association
          </p>
        </div>

        {/* Minimal Scroll Indicator with pulse */}
        {/* <div className="pt-32 animate-fade-in-delayed">
          <div className="w-px h-24 bg-gradient-to-b from-secondary/60 to-transparent mx-auto animate-pulse-slow" />
        </div> */}

        {/* Scroll Indicator */}
        {/* <div className="absolute pt-32 bottom-12 left-1/2 transform -translate-x-1/2 ">
          <div className="w-px h-24 bg-gradient-to-b from-secondary to-transparent mx-auto animate-pulse-slow" />
        </div> */}

      </div>
    </section>
  );
}

export default Hero

